import { render, staticRenderFns } from "./AdminWardAssignment.vue?vue&type=template&id=0bbdc8ae&"
import script from "./AdminWardAssignment.vue?vue&type=script&lang=js&"
export * from "./AdminWardAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports